<template>
  <div class="my-pooq-view-wrapper">
    <div class="sticky-area">
      <common-header-wrapper :title="getTitle()" :back-fn="back" :close-fn="close" :is-back-btn="true" :is-close-btn="true"></common-header-wrapper>
      <customer-main-menu v-if="isVisible" :menu-index="mainMenuIndex" :change-menu-fn="changeMainMenu"/>
      <portal-target name="customer-search"></portal-target>
    </div>
    <!-- 이용내역 서브 메뉴 -->
    <div :class="getWrapperClass" :style="toggle ? overflowStyle : ''" data-scroll-element="true">
      <router-view name="faq" :key="'customer_' + mainMenuIndex"></router-view>
      <router-view name="notice_list" :key="'customer_' + mainMenuIndex"></router-view>
      <router-view name="notice_view" :key="'notice_detail'"></router-view>
      <router-view name="customer_user_qna" key="customer_user_qna"></router-view>
    </div>
  </div>
</template>

<script>
import CustomerMainMenu from '@/components/lnb/customer/CustomerMainMenu'
import { enableBodyScroll } from '@/common/util/ui.utils'
import { mapGetters } from 'vuex'
import { EventBus } from '@/components/eventbus/EventBus'
import utils from '@/common/util/utils'
import CommonHeaderWrapper from '@/components/header/template/CommonHeaderWrapper'
import { isApp } from '@/common/util/common'
export default {
  name: 'CustomerView',
  components: {
    CommonHeaderWrapper,
    CustomerMainMenu
  },
  data () {
    return {
      mainMenuIndex: 0,
      referer: '',
      overflowStyle: {
        overflow: 'hidden'
      },
      toggle: false,
      device: utils.cookies.getDevice()
    }
  },
  methods: {
    getTitle () {
      if (this.$route.name === 'notice_view') {
        return '공지사항'
      } else {
        return '고객센터'
      }
    },
    changeMainMenu (mainMenuObject) {
      this.mainMenuIndex = mainMenuObject.index
      if (mainMenuObject.path.indexOf('https') > -1) {
        location.href = mainMenuObject.path
      } else {
        this.$router.push(mainMenuObject.path)
      }
    },
    back () {
      if (this.$route.name === 'notice_view') {
        this.$router.back()
      } else {
        this.$router.back()
      }
    },
    close () {
      this.$router.replace(this.getBeforePathOpenMyPooq)
    }
  },
  computed: {
    ...mapGetters(['getBeforePathOpenMyPooq']),
    getWrapperClass () {
      let defaultClass = 'my-wrap'
      const name = this.$route.name

      if (name === 'faq') {
        defaultClass += ' faq'
      } else if (name === 'notice_list') {
        defaultClass += ' notice'
        if (this.$route.name === 'notice_view') {
          defaultClass += ' view'
        }
      }
      return defaultClass
    },
    isVisible () {
      return !isApp() && this.$route.name !== 'notice_view'
    }
  },
  mounted () {
    enableBodyScroll()
  },
  created () {
    EventBus.$on('toggle', (toggleSecet) => {
      this.toggle = toggleSecet
    })
    const lastPath = this.$route.name
    if (lastPath === 'customer') {
      this.$router.replace('/customer/faq')
    }
    switch (lastPath) {
      case 'user_qna':
        this.mainMenuIndex = 0
        break
      case 'notice_list':
      case 'notice_view':
        this.mainMenuIndex = 1
        break
    }
  }
}
</script>
<style scoped>
  .my-pooq-content-body {
    position: relative;
    width: 100%;
  }
  .my-wrap {
    width: 100%;
    min-height: 100%;
    padding-bottom: 0;
  }
  .not-mobile {
    padding-top: 0 !important;
  }
</style>
